/**
 * Presence channel name constants.
 *
 * Keep channel names centralized so we can later switch to scoped channels
 * (e.g. presence-project-{id}) without touching UI code.
 */

/** Authenticated presence channel (requires POST /api/v1/socket/auth). */
export const PRESENCE_CHANNEL = "presence-portal"

/**
 * Legacy public fallback used before backend socket auth existed.
 * Public channels do not support member_added / member_removed.
 */
export const PUBLIC_PRESENCE_CHANNEL = "amok-users"

/** Active channel for online/offline presence. */
export const getActivePresenceChannel = () => PRESENCE_CHANNEL

/**
 * Build scoped channel names for future use.
 * @param {'project'|'workspace'|'conversation'} scope
 * @param {string|number} id
 */
export const getPresenceChannel = (scope, id) => {
  if (!scope || id == null || id === "") return getActivePresenceChannel()
  return `presence-${scope}-${id}`
}

/**
 * Normalize app user → presence member shape expected by the UI.
 * Backend auth returns the same identity via channel_data.user_id / user_info.
 */
export const toPresenceMember = user => {
  if (!user) return null

  const id =
    user.id != null
      ? String(user.id)
      : user.user_id != null
        ? String(user.user_id)
        : ""
  if (!id) return null

  const name =
    [user.first_name, user.last_name].filter(Boolean).join(" ").trim() ||
    user.name ||
    user.full_name ||
    user.email ||
    "User"

  const avatar =
    user.avatar ||
    user.profile_picture ||
    user.profile_image ||
    user.user_pic ||
    null

  return { id, name, avatar }
}
